import { useEffect } from "react";
import { FaApple, FaFacebookSquare } from "react-icons/fa";
import { useMutation } from "@tanstack/react-query";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { facebookLogin } from "../../api/auth";
import { useTranslation } from "../../hooks/useTranslation";

const FacebookLogin = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { storeDataToStorage } = useAuth();

  const loginMutation = useMutation({
    mutationFn: facebookLogin,
    onSuccess: ({ data }) => {
      const { token, user } = data;
      toast.success("Login successful!");
      storeDataToStorage(user, token);

      if (user.role === "admin") navigate("/admindashboard");
      else if (user.role === "user") navigate("/");
      else if (user.role === "owner") navigate("/ownerdashboard");
    },
    onError: (error) => {
      const errorMessage =
        error?.response?.data?.message || "Something went wrong.";
      toast.error(errorMessage);
    },
  });

  useEffect(() => {
    if (!window.FB) {
      const fbScript = document.createElement("script");
      fbScript.src = "https://connect.facebook.net/en_US/sdk.js";
      fbScript.async = true;
      fbScript.defer = true;
      fbScript.crossOrigin = "anonymous";
      fbScript.onload = initFacebookSDK;
      document.body.appendChild(fbScript);
    } else {
      initFacebookSDK();
    }
  }, []);

  const initFacebookSDK = () => {
    const facebookAppId = process.env.REACT_APP_FACEBOOK_APP_ID;
    
    if (!facebookAppId) {
      console.warn("Facebook App ID is not configured. Facebook login will be disabled.");
      return;
    }

    window.fbAsyncInit = function () {
      window.FB.init({
        appId: facebookAppId,
        cookie: true,
        xfbml: true,
        version: "v19.0",
      });
    };
  };

  const checkLoginState = () => {
    if (!process.env.REACT_APP_FACEBOOK_APP_ID) {
      toast.error("Facebook login is not configured.");
      return;
    }

    if (!window.FB) {
      toast("Facebook SDK not loaded yet. Please try again in a second.");
      return;
    }

    window.FB.login(
      (response) => {
        if (response.authResponse) {
          const accessToken = response.authResponse.accessToken;
          loginMutation.mutate({ accessToken });
        } else {
          toast("User cancelled login or did not fully authorize.");
        }
      },
      { scope: "public_profile,email" }
    );
  };

  return (
    <button
      className=" flex items-center justify-center gap-[16px] w-full text-center text-[#fff] md:text-[20px] text-[16px] font-medium border  p-[20px] rounded-[10px] mt-[20px] bg-[#3D5A98] hover:bg-[#324b81]"
      onClick={checkLoginState}
    >
      <FaFacebookSquare size={20} className="text-[#fff]" />
      {t("login").continueFacebook}
    </button>
  );
};

export default FacebookLogin;
